import React from 'react';
import { TextFieldProps } from './types';
import { TextFieldView } from './view';

export class TextFieldController extends React.Component<TextFieldProps> {
  handleChange = (e: React.ChangeEvent) => {
    const node: any = e.target;
    const isValid = this.props.validate(node.value);
    let value = node.value;

    if (this.props.numbersOnly) {
      value = value.replace(/[^0-9\-() +,.#]/g, '');
    }

    if (isValid && this.props.format) {
      value = this.props.format(value);
    }

    this.props.onChange({
      value,
      isValid,
      name: this.props.name,
    });
  };

  handleBlur = () => {
    this.props.onBlur({
      value: this.props.value,
      name: this.props.name,
      isValid: this.props.isValid,
    });
  };

  render() {
    return (
      <TextFieldView
        {...this.props}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
      />
    );
  }
}
